import { createFromIconfontCN } from "@ant-design/icons";

const MyIcon = createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/font_2560535_1pngz2wtxjs.js",
  extraCommonProps: {},
});

export default MyIcon;
